export default "__VITE_ASSET__15154a55__"